import { Component } from '@angular/core';
import { PageSlotModule } from '@spartacus/storefront';
import { ModalLoginComponent } from '../../components/static/modal-login/modal-login.component';

@Component({
  selector: 'wc-header',
  templateUrl: './header.component.html',
  standalone: true,
  imports: [PageSlotModule, ModalLoginComponent]
})
export class HeaderComponent {}
